import { createContext, useContext, useState, useEffect} from "react";
import { api } from "../../services/api";
import { useHistory } from "react-router";
// eslint-disable-next-line
import Cookies, { set } from "js-cookie";
import {alert} from '../Alert'

const UserContext = createContext();

const UserProvider = ({children}) => {


    const history = useHistory();
    const [user, setUser] = useState(null)

    const CRYPTO_KEY = "StrucTHotel"

    var CryptoJS = require("crypto-js");

    const handleCookies = async () => {
        const userCookie = await Cookies.get('user');
        Cookies.raw = true
        if(userCookie !== undefined) {
            var bytes = CryptoJS.AES.decrypt(userCookie, CRYPTO_KEY);
            const retrievedUser = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(retrievedUser)
            setUser(retrievedUser);
            
            let tmp = retrievedUser.type.charAt(0).toUpperCase() + retrievedUser.type.slice(1);

            api.defaults.headers.common[`X-${tmp}-Token`] = retrievedUser.authentication_token
            api.defaults.headers.common[`X-${tmp}-Email`] = retrievedUser.email
            
            showClient(userCookie)
        }
        return userCookie
    }

    useEffect(() => {

        handleCookies();

    }, [])

    const updateClient = async ({name, email, password})  => {
        try{
            const response = await api.patch(`clients/update/${user.id}`, {
                name,
                email
            })
            if(response.data){
                var encrypted = CryptoJS.AES.encrypt(JSON.stringify({...response.data, type: 'client'}), CRYPTO_KEY).toString();
                Cookies.set('user', encrypted, {expires: 1})

                setUser(response.data)
                history.go(0)
            }

        }catch(e){
            alert("Erro, tente novamente", 'error')
        }
    }

    const showClient = async () => {
        try{
            const response = await api.get(`/clients/show/${user.id}`)
            var encrypted = CryptoJS.AES.encrypt(JSON.stringify({...response.data, type: 'client'}), CRYPTO_KEY).toString();
            Cookies.set('user', encrypted, {expires: 1})
            setUser(response.data)
            console.log(response.data)
            api.defaults.headers.common[`X-Client-Token`] = response.data.authentication_token
            api.defaults.headers.common[`X-Client-Email`] = response.data.authentication_token
            history.go(0)

        } catch(e){
            console.error(e)
        }
    }

    const logout = async () => {
        if (window.confirm("Você realmente deseja sair de sua conta?")){
            try{
                const response = await api.post(`${user.type}s/logout`)
                if (response){
                    console.log (response)
                }
            }catch(e){
                alert("Erro, tente novamente", 'error')
            }finally{
                Cookies.remove('user')
                history.push('/')
                history.go(0)
            }
        }
    }

    const sign_out = async () => {
        if (window.confirm("Você realmente deseja sair de sua conta?")){
            Cookies.remove('user')
            history.push('/')
            history.go(0)
        }
    }

    const login_cliente = async ({email, password}) => {
        try{
            const response = await api.post('clients/login', {
                email,
                password
            });
            if(response.data){
                setUser({...response.data, type: 'client'})
                var encrypted = CryptoJS.AES.encrypt(JSON.stringify({...response.data, type: 'client'}), CRYPTO_KEY).toString();
                console.log(encrypted);
                Cookies.set('user', encrypted, {expires: 1});
                history.push('/')
                api.defaults.headers.common['X-Client-Token'] = response.data.authentication_token
                api.defaults.headers.common['X-Client-Email'] = response.data.email
            }
        }catch(e){
            alert('Usuário não autorizado', 'error')
        }
    }

    const login_retailer = async ({email, password}) => {
        try{
            const response = await api.post('retailers/login', {
                email,
                password
            });
            if(response.data){
                setUser({...response.data, type: 'retailer'})
                var encrypted = CryptoJS.AES.encrypt(JSON.stringify({...response.data, type: 'retailer'}), CRYPTO_KEY).toString();
                Cookies.set('user', encrypted, {expires: 1});
                history.push('/')
                api.defaults.headers.common['X-Retailer-Token'] = response.data.authentication_token
                api.defaults.headers.common['X-Retailer-Email'] = response.data.email
            }
        }catch(e){
            alert('Usuário não autorizado', 'error')
        }
    }

        const login_admin = async ({email, password}) => {
            try{
                const response = await api.post('admins/login', {
                    email,
                    password
                });
                if(response.data){
                    setUser({...response.data, type: 'admin'})
                    var encrypted = CryptoJS.AES.encrypt(JSON.stringify({...response.data, type: 'admin'}), CRYPTO_KEY).toString();
                    Cookies.set('user', encrypted, {expires: 1});
                    history.push('/')
                    api.defaults.headers.common['X-Admin-Token'] = response.data.authentication_token
                    api.defaults.headers.common['X-Admin-Email'] = response.data.email
                }
            }catch(e){
                alert('Usuário não autorizado', 'error')
            }
    }


    return (
        <UserContext.Provider value={{user, login_retailer, login_admin, login: login_cliente, logout, updateClient, setUser, showClient, sign_out}}>
            {children}
        </UserContext.Provider>
    )
}

export const useUserContext = () => {
    const context = useContext(UserContext);

    return context;
}

export default UserProvider;